var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7512 14.9659V13.4969C11.7512 12.7178 11.4417 11.9705 10.8908 11.4196C10.3398 10.8686 9.59255 10.5591 8.81338 10.5591H4.4066C3.62744 10.5591 2.88018 10.8686 2.32923 11.4196C1.77827 11.9705 1.46875 12.7178 1.46875 13.4969V14.9659",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6107 7.62131C8.23324 7.62131 9.54856 6.30599 9.54856 4.68346C9.54856 3.06093 8.23324 1.74561 6.6107 1.74561C4.98817 1.74561 3.67285 3.06093 3.67285 4.68346C3.67285 6.30599 4.98817 7.62131 6.6107 7.62131Z",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1575 14.9661V13.4972C16.157 12.8462 15.9404 12.2139 15.5415 11.6994C15.1427 11.185 14.5844 10.8175 13.9541 10.6548",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.752 1.84131C12.3839 2.00311 12.944 2.37064 13.344 2.88594C13.744 3.40125 13.9611 4.03503 13.9611 4.68735C13.9611 5.33968 13.744 5.97346 13.344 6.48876C12.944 7.00407 12.3839 7.3716 11.752 7.5334",
    stroke: "#D6B893",
    strokeWidth: 1.46893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_802"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6271,
    height: 17.6271,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/Icon 8.6990f955ae68f9670556c93b5109c662.svg";
export { ForwardRef as ReactComponent };